"use client";

import { usePathname } from "next/navigation";
import Link, { LinkProps } from "next/link";
import React, { PropsWithChildren, useMemo } from "react";

type ActiveLinkAppProps = LinkProps & {
  className?: string;
  activeClassName: string;
};

const ActiveLinkApp = ({
  children,
  activeClassName,
  className,
  ...props
}: PropsWithChildren<ActiveLinkAppProps>) => {
  const pathname = usePathname();

  const computedClassName = useMemo(() => {
    if (!pathname) return className;
    const linkPathname = new URL(
      (props.as || props.href) as string,
      "http://internal.local",
    ).pathname;
    return linkPathname === pathname
      ? `${className} ${activeClassName}`.trim()
      : className;
  }, [pathname, props.as, props.href, activeClassName, className]);

  return (
    <Link className={computedClassName} {...props}>
      {children}
    </Link>
  );
};

export default ActiveLinkApp;
